export default __webpack_public_path__ + "static/media/Zing 2.2.9a6460c9.gif";